import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccountStatusService {
  private isSuspended = false;
  private isWarningActive = false;

  setSuspended(status: boolean) {
    this.isSuspended = status;
    sessionStorage.setItem('accountSuspended', String(status));
  }

  setWarning(status: boolean) {
    this.isWarningActive = status;
    sessionStorage.setItem('accountWarning', String(status));
  }

  getSuspended(): boolean {
    return this.isSuspended || sessionStorage.getItem('accountSuspended') === 'true';
  }

  getWarning(): boolean {
    return this.isWarningActive || sessionStorage.getItem('accountWarning') === 'true';
  }

  clearAll() {
    this.isSuspended = false;
    this.isWarningActive = false;
    sessionStorage.removeItem('accountSuspended');
    sessionStorage.removeItem('accountWarning');
  }
}
